<div class="row">
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-3"></div>
      <div class="col-sm-6">
        <form [formGroup]="trainingForm">
          <input type="hidden" formControlName="id" />
          <div class="form-group">
            <label class="lbl">{{customerSpecificSchool.languageLbl}}</label>
            <kendo-dropdownlist class="kendoInput" name="languageCode"
                                formControlName="languageCode"
                                [data]="getLanguages"
                                [textField]="'languageCode'"
                                [valueField]="'languageCode'"
                                [ngModel]="{languageCode:selectedLanguage}"
                                (selectionChange)="lanaguageChange($event)"
                                [ngClass]="{'borderRed':customerSpecificSchool.isLanguageCodeEmpty && customerSpecificSchool.isSubmitted}"
                                (blur)="validateCustomerSpecificSchoolForm()">
            </kendo-dropdownlist>
          </div>
          <!--[for]="terms"-->
          <div class="form-group">
            <kendo-label class="k-radio-label"
                         text="Customer Specific School Input Method &nbsp; &nbsp;   "></kendo-label>
            <input type="radio"
                   name="customerSpecificSchoolInputMethod"
                   value="TextEditor"
                   #textEditor [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="customerSpecificSchoolInputMethod"
                   kendoRadioButton />
            <label class="k-label" [for]="textEditor">Text Editor &nbsp;</label>

            <input type="radio"
                   name="customerSpecificSchoolInputMethod"
                   value="FileUpload"
                   #fileUpload [ngModelOptions]="{standalone: true}"
                   [(ngModel)]="customerSpecificSchoolInputMethod"
                   kendoRadioButton />
            <label class="k-label" [for]="fileUpload">File Upload</label>
          </div>
          <div class="form-group" *ngIf="customerSpecificSchoolInputMethod==='TextEditor'">
            <label class="lbl">{{customerSpecificSchool.descriptionLbl}}</label>
            <!--<textarea kendoTextArea class="kendoInput textArea-height"
    formControlName="description" [disabled]="!enableText" [ngClass]="{'borderRed':customerSpecificSchool.isDescriptionEmpty && customerSpecificSchool.isSubmitted}" (blur)="validateCustomerSpecificSchoolForm()"></textarea>-->
            <kendo-editor class="kendoInput" formControlName="description"
                          [ngClass]="{'borderRed':customerSpecificSchool.isDescriptionEmpty && customerSpecificSchool.isSubmitted}" (blur)="validateCustomerSpecificSchoolForm()"></kendo-editor>
          </div>
          <div class="form-group" *ngIf="customerSpecificSchoolInputMethod==='FileUpload'">
            <div class="kendoInput">
              <app-upload [multiple]="false" (fileSelect)="customerSpecificSchoolSelected($event)"
                          [uploadFolderPath]="'TempDocs\\CustomerSpecificSchool'"
                          [ngClass]="{'borderRed':customerSpecificSchool.isEmptyCustomerSpecificSchoolUrlPath && customerSpecificSchool.isSubmitted}"
                          (uploadSuccess)="customerSpecificSchoolUploadSuccess($event)"
                          [fileRestrictions]="fileRestrictions"></app-upload>
            </div>
            <!--<label class="lblCls">
      {{customerSpecificSchoolUrlPath}}
    </label>-->

          </div>
          <div class="form-group" *ngIf="customerSpecificSchoolInputMethod==='FileUpload'">
            <div id="pdfIframediv" class="row myIframe" *ngIf="customerSpecificSchoolUrl">
              <iframe class="PdfReport"
                      [src]="customerSpecificSchoolUrl"
                      type="application/pdf"></iframe>
            </div>
          </div>



        </form>
        <br />
        <div class="align-center">
          <div class="btn-group" role="group">
            <button kendoButton class=" m-3 btn k-button"
                    (click)="resetForm()">
              Cancel
            </button> &nbsp;&nbsp;
            <button kendoButton class=" m-3 btn btn-success"
                    (click)="saveCustomerSpecificSchool()">
              Save<!--<kendo-loader style="color:blue"></kendo-loader>-->
              <!--*ngIf="saveInProcess"-->
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>

  </div>
</div>
